import { NavLink } from "react-router-dom";

const capitalize = (str) => {
    return str.charAt(0).toUpperCase() + str.slice(1);
}
const RowTeam = ({index,data}) =>
{
    return(
        <tr>
            <td>{index}</td>
            <td><figure className="avatar"> <img src={data.image} alt={data.name}/> </figure></td>
            <td>{data.name}</td>
            <td>
                { data.leader ?
                <NavLink to={`/employee/${data.leader._id}`} className='badge badge-primary' style={{padding:'0px 10px 0px 0px'}}>
                    <img src={data.leader.image} className='avatar avatar-sm mr-2' alt="Person" width="96" height="96"/>
                    {data.leader.name}
                </NavLink>
                :
                <div className='badge  badge-light' style={{padding:'0px 10px 0px 0px'}}>
                    <img src='/assets/icons/user.png' className='avatar avatar-sm mr-2' alt="data" width="96" height="96"/>
                    No Leader
                </div> }
            </td>
            <td><div className={`badge ${data.status==='active' ? 'badge-success' :'badge-danger'}`}>{capitalize(data.status)}</div></td>
            <td><NavLink to={`/team/${data._id}`} className="btn btn-secondary">Detail</NavLink></td>
        </tr>
    );
}

export default RowTeam;